import type { components } from '../magpiie-client/api-types';
import type { ChannelsState } from './types/channels';
import type { OrganizationsState } from './types/organizations';

export type User = components['schemas']['UserResponseDto'];
export type UpdateUserType = components['schemas']['UpdateUserProfileDto'];
export type FolderType = components['schemas']['RevisionFolderDto'];
export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  accessToken: string | null;
  isUserLoading: boolean;
  isInitializing: boolean; // True during initial auth check via refresh token
}

export interface RootState {
  user: AuthState;
  channels: ChannelsState;
  organizations: OrganizationsState;
}

export const LOGIN = 'login';
export const GOOGLE_AUTH_LOGIN = 'googleAuthLogin';
export const UPDATE_TOKEN = 'updateToken';
export const LOGOUT = 'logout';
export const UPDATE_USER = 'updateUser';

// Action interfaces
interface LoginAction {
  type: typeof LOGIN;
  payload: User;
}

interface GoogleAuthLoginAction {
  type: typeof GOOGLE_AUTH_LOGIN;
  payload: User;
}

interface UpdateTokenAction {
  type: typeof UPDATE_TOKEN;
  payload: string; // access token string
}

interface LogoutAction {
  type: typeof LOGOUT;
}

interface UpdateUserAction {
  type: typeof UPDATE_USER;
  payload: Partial<User>;
}

export type AuthActionTypes =
  | LoginAction
  | GoogleAuthLoginAction
  | UpdateTokenAction
  | LogoutAction
  | UpdateUserAction;

// Action creators (for typed reducers)
import { createAction } from '@reduxjs/toolkit';
export const login = createAction<User>(LOGIN);
export const googleAuthLogin = createAction<User>(GOOGLE_AUTH_LOGIN);
export const updateToken = createAction<string>(UPDATE_TOKEN);
export const logout = createAction(LOGOUT);
export const updateUser = createAction<Partial<User>>(UPDATE_USER);

// Auth async helpers
export const fetchUserRequest = createAction('fetchUserRequest');
export const fetchUserFailure = createAction<string | undefined>(
  'fetchUserFailure'
);
export const initializeAuthComplete = createAction('initializeAuthComplete');
